import invariant from 'invariant';
import { ElementType } from 'react';

import {
  CmsMultiInput,
  ExtraDataType,
} from 'modules/cms/blocks/Multi/CmsMultiInput';

import { Field } from './Field/Field';

type Props = {
  name: string;
  component?: ElementType;
  label?: string;
  description?: string;
  matchGeneralError?: string;
  placeholder?: string;
  maxInputs: number;
  type?: string;
  disabled?: boolean;
  collapsible?: boolean;
  extraData?: Array<ExtraDataType>;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  extraAnalyticsData?: Array<Record<string, any>>;
  hideControls?: boolean;
  addText?: string;
  removeText?: string;
  showEmpty?: boolean;
  startWithNone?: boolean;
  errors?: APIErrors;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  defaultData?: any;
  sortBy?: (
    arg0: {
      value: unknown;
      index: number;
    },
    arg1: {
      value: unknown;
      index: number;
    }
  ) => number;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onError?: (...args: Array<any>) => any;
};

export function MultiInputField({
  name,
  component,
  label,
  description,
  matchGeneralError,
  placeholder,
  maxInputs,
  type = 'text',
  disabled,
  collapsible,
  extraData,
  extraAnalyticsData,
  hideControls,
  addText,
  removeText,
  showEmpty,
  startWithNone,
  errors,
  defaultData,
  sortBy,
  onError,
}: Props) {
  return (
    <Field
      name={name}
      label={label}
      description={description}
      matchGeneralError={matchGeneralError}
      renderInput={({ value, id, qaId, updateValueWith, hasError }) => {
        invariant(
          Array.isArray(value),
          `Invalid value for MultiInputField named ${name}: ${value}`
        );
        return (
          <CmsMultiInput
            id={id}
            component={component}
            name={name}
            type={type}
            values={value}
            hasError={hasError}
            maxInputs={maxInputs}
            data-qa-id={qaId}
            placeholder={placeholder}
            onChange={updateValueWith}
            disabled={disabled}
            // @ts-expect-error TS(2322): Type '{ id: string; component: ElementType<any> | ... Remove this comment to see the full error message
            collapsible={collapsible}
            extraData={extraData}
            extraAnalyticsData={extraAnalyticsData}
            hideControls={hideControls}
            addText={addText}
            removeText={removeText}
            showEmpty={showEmpty}
            startWithNone={startWithNone}
            defaultData={defaultData}
            errors={errors}
            sortBy={sortBy}
            onError={onError}
          />
        );
      }}
    />
  );
}
